import React, { Fragment, useState, useRef } from "react";
import CustomLoader from "../../customLoader/CustomLoader";
import GetAdminService from "../../../services/admin/GetAdminService";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import CreateTeacher from "./CreateTeacher";
import "../AdminPages.css";

const STATIC_TEACHERS = [
  {
    id: 1,
    first_name: "Maria",
    last_name: "Santos",
    email: "maria.santos@school.edu",
    mobile: "+13235550101",
    assignments: [
      { grade: "09", course: { id: "alg-1", name: "Algebra I" } },
      { grade: "10", course: { id: "geo", name: "Geometry" } }
    ]
  },
  {
    id: 2,
    first_name: "James",
    last_name: "Okeke",
    email: "james.okeke@school.edu",
    mobile: "+13235550122",
    assignments: [
      { grade: "11", course: { id: "pre-calc", name: "Pre-Calculus" } }
    ]
  },
  {
    id: 3,
    first_name: "Priya",
    last_name: "Nair",
    email: "priya.nair@school.edu",
    mobile: "+13235550133",
    assignments: [
      { grade: "12", course: { id: "eng-12", name: "English 12" } },
      { grade: "11", course: { id: "eng-11", name: "English 11" } }
    ]
  }
];

const Teachers = () => {
  const [schoolName, setSchoolName] = useState("");
  const [showSchoolNameContainer, setShowSchoolNameContainer] = useState(false);
  const [schoolNameList, setSchoolNameList] = useState([]);
  const schoolNameRef = useRef();
  const timeoutRef = useRef();
  const [schoolNameLoading, setSchoolNameLoading] = useState(false);
  const [schoolId, setSchoolId] = useState();
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [teacherList, setTeacherList] = useState([]);
  const [openCreateTeacher, setOpenCreateTeacher] = useState(false);
  const [modifyTeacher, setModifyTeacher] = useState(null);

  const getSchoolsList = (value) => {
    setSchoolNameLoading(true);
    setShowSchoolNameContainer(true);
    setSchoolNameList([]);
    GetAdminService.getSchoolsList(value)
      .then((data) => {
        setSchoolNameList(data?.data?.school || []);
        setSchoolNameLoading(false);
      })
      .catch(() => {
        setSchoolNameLoading(false);
      });
  };

  const handleSchoolName = () => {
    clearTimeout(timeoutRef.current);
    setSchoolName(schoolNameRef.current.value);
    if (!schoolNameRef.current.value) {
      setShowSchoolNameContainer(false);
      setSchoolNameList([]);
      setTeacherList([]);
      setSchoolId(undefined);
      setSelectedSchool(null);
    } else {
      timeoutRef.current = setTimeout(() => {
        getSchoolsList(schoolNameRef.current.value);
      }, 1000);
    }
  };

  const handleSelectedSchoolName = (item) => {
    setSchoolNameList([item]);
    setShowSchoolNameContainer(false);
    setSchoolName(item?.name);
    setSchoolId(item?.id);
    setSelectedSchool(item);
    setTeacherList(STATIC_TEACHERS.map((teacher) => ({ ...teacher })));
  };

  const openModify = (item) => {
    setModifyTeacher(item);
    setOpenCreateTeacher(true);
  };

  const closeDrawer = () => {
    setOpenCreateTeacher(false);
    setModifyTeacher(null);
  };

  const saveTeacher = (teacherData) => {
    if (modifyTeacher) {
      setTeacherList((list) =>
        list.map((item) =>
          item.id === modifyTeacher.id ? { ...item, ...teacherData } : item
        )
      );
    } else {
      setTeacherList((list) => [
        ...list,
        { ...teacherData, id: Date.now() }
      ]);
    }
    closeDrawer();
  };

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="csv-import-container">
            <div className="admin-students-page-header">
              <h2>Teachers</h2>
              {schoolId && (
                <button
                  className="admin-students-new-btn"
                  onClick={() => {
                    setModifyTeacher(null);
                    setOpenCreateTeacher(true);
                  }}
                >
                  <FontAwesomeIcon icon={faUser} />
                  New Teacher
                </button>
              )}
            </div>

            <div className="admin-students-school-selector">
              <label>Select School</label>
              <div className="school-input-wrapper">
                <input
                  ref={schoolNameRef}
                  type="text"
                  placeholder="Type to search school name..."
                  value={schoolName}
                  onChange={handleSchoolName}
                  autoComplete="off"
                />
                {showSchoolNameContainer && (
                  <ul className="school-dropdown">
                    {schoolNameLoading && <CustomLoader />}
                    {schoolNameList?.length > 0 &&
                      schoolNameList.map((item, index) => (
                        <li
                          onClick={() => handleSelectedSchoolName(item)}
                          key={item?.id || index}
                        >
                          {item.name}
                        </li>
                      ))}
                  </ul>
                )}
              </div>
            </div>

            {schoolId && (
              <div className="admin-students-list-section">
                <div className="admin-student-list-container">
                  <p className="admin-students-heading">Teachers</p>
                  {teacherList.length === 0 && (
                    <p className="help-text">No teachers found for this school.</p>
                  )}
                  {teacherList.map((item) => (
                    <div
                      key={item.id}
                      className="student-list"
                      onClick={() => openModify(item)}
                    >
                      <span className="student-name">
                        {item.first_name} {item.last_name}
                      </span>
                      <span className="student-email">{item.email}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {openCreateTeacher && (
              <CreateTeacher
                school={selectedSchool}
                modify={modifyTeacher}
                onClose={closeDrawer}
                onSave={saveTeacher}
              />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Teachers;
